// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"048066e0","355":"c397f7ba"}[chunkId] + ".chunk.js";
};